'use client'

import { memo } from 'react'

// ============================================================================
// Types
// ============================================================================

interface MessageBubbleProps {
  type: 'user' | 'assistant' | 'system'
  content: string
  timestamp: Date
  className?: string
}

// ============================================================================
// Component
// ============================================================================

export const MessageBubble = memo(function MessageBubble({
  type,
  content,
  timestamp,
  className = ''
}: MessageBubbleProps) {

  const bubbleStyles = {
    user: 'bg-blue-600 text-white ml-auto',
    assistant: 'bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white',
    system: 'bg-yellow-50 dark:bg-yellow-900/20 text-yellow-900 dark:text-yellow-200 border border-yellow-200 dark:border-yellow-800'
  }

  const iconMap = {
    user: '👤',
    assistant: '🤖',
    system: 'ℹ️'
  }

  const maxWidth = type === 'system' ? 'max-w-full' : 'max-w-2xl'

  return (
    <div className={`flex ${type === 'user' ? 'justify-end' : 'justify-start'} ${className}`}>
      <div className={`${bubbleStyles[type]} ${maxWidth} rounded-lg px-4 py-3 shadow-sm`}>
        {/* Header */}
        <div className="flex items-center gap-2 mb-1">
          <span className="text-sm">{iconMap[type]}</span>
          <span className="text-xs opacity-70">
            {timestamp.toLocaleTimeString('pt-BR', {
              hour: '2-digit',
              minute: '2-digit'
            })}
          </span>
        </div>

        {/* Content */}
        <div className="whitespace-pre-wrap break-words">
          {content}
        </div>
      </div>
    </div>
  )
})
